import React, { createContext, useContext, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';







import { STAGE_ICONS } from '../shared/stageIcons';







const EMPTY_TIMINGS = [];







const normalise = word => word.toLowerCase().replace(/[’‘]/g, "'").replace(/[^\p{L}\p{N}']/gu, '');







// Keep measured speech cues; estimate only script tokens absent from the ASR.







function buildTimeline(narration, wordTimings, duration) {







  const script = narration.match(/\S+/g) || [];







  const spoken = (Array.isArray(wordTimings) ? wordTimings : []).filter(item =>







    item && typeof item.word === 'string' && Number.isFinite(item.start) && Number.isFinite(item.end) && item.start >= 0 && item.end >= item.start);







  const length = duration > 0 ? duration : spoken.length ? spoken[spoken.length - 1].end : script.length / 2.5;







  const mapped = Array(script.length).fill(null);







  if (spoken.length) {







    const rows = script.length + 1, columns = spoken.length + 1;







    const scores = new Uint16Array(rows * columns);







    const source = script.map(normalise), audio = spoken.map(item => normalise(item.word));







    for (let i = 1; i < rows; i += 1) for (let j = 1; j < columns; j += 1) {







      scores[i * columns + j] = source[i - 1] && source[i - 1] === audio[j - 1]







        ? scores[(i - 1) * columns + j - 1] + 1







        : Math.max(scores[(i - 1) * columns + j], scores[i * columns + j - 1]);







    }







    let i = script.length, j = spoken.length;







    while (i > 0 && j > 0) {







      if (source[i - 1] && source[i - 1] === audio[j - 1]) {







        mapped[i - 1] = { ...spoken[j - 1], measured: true }; i -= 1; j -= 1;







      } else if (scores[(i - 1) * columns + j] >= scores[i * columns + j - 1]) i -= 1;







      else j -= 1;







    }







  }







  const measured = mapped.filter(Boolean).length;







  for (let index = 0; index < mapped.length;) {







    if (mapped[index]) { index += 1; continue; }







    const from = index;







    while (index < mapped.length && !mapped[index]) index += 1;







    const start = from ? mapped[from - 1].end : 0;







    const end = Math.max(start, index < mapped.length ? mapped[index].start : length);







    const span = (end - start) / (index - from);







    for (let k = from; k < index; k += 1) mapped[k] = {







      start: start + (k - from) * span, end: start + (k - from + 1) * span, measured: false,







    };







  }







  return { words: mapped, mode: measured === script.length ? 'measured' : measured ? 'mixed' : 'estimated' };







}







function wordOffset(narration, phrase) {







  const at = narration.indexOf(phrase);







  if (at < 0) throw new Error(`Missing narration cue: ${phrase}`);







  return narration.slice(0, at).trim().split(/\s+/).filter(Boolean).length;







}







function cueTime(narration, timeline, phrase) {







  return timeline.words[wordOffset(narration, phrase)]?.start ?? Infinity;







}







function buildBeats(narration, timeline, phrases, endPhrase) {







  const script = narration.match(/\S+/g) || [];







  const offsets = phrases.map(phrase => wordOffset(narration, phrase));







  const end = endPhrase ? wordOffset(narration, endPhrase) : script.length;







  return offsets.map((from, index) => ({







    start: timeline.words[from]?.start ?? Infinity,







    text: script.slice(from, offsets[index + 1] ?? end).join(' '),







    timings: timeline.words.slice(from, offsets[index + 1] ?? end).map(word => word.start),







  }));







}







function activeIndex(items, now) {







  let index = 0;







  items.forEach((item, i) => { if (now >= item.start) index = i; });







  return index;







}







// Keep the same timing-input aliases and stable timeline as What Is Tribe.



function useNarrationTimeline(narration, wordTimings, duration) {



  const timingKey = JSON.stringify(Array.isArray(wordTimings)



    ? wordTimings.map(item => [item?.word, item?.start, item?.end]) : []);



  return useMemo(() => buildTimeline(narration, wordTimings, duration), [narration, duration, timingKey]);



}







// Read the audio clock each frame, but render only when a word boundary,







// pause, seek or playback rate changes. Native CSS handles the motion.







function useLessonClock({ time = 0, audioElement, audioRef, playbackId, audioStatus } = {}, timeline) {







  const boundaries = useMemo(() => timeline.words.map(word => word.start), [timeline]);







  const sourceTime = Number.isFinite(time) ? Math.max(0, time) : 0;







  const parentAnchor = useRef({ time: sourceTime, stamp: null });







  const controller = useRef({ time: sourceTime, boundary: -2, playing: false, rate: 1, syncId: 0 });







  const [clock, setClock] = useState({ now: sourceTime, playing: audioStatus === 'Playing', rate: 1, syncId: 0, seeking: false });







  const boundaryAt = current => {







    let low = 0, high = boundaries.length;







    while (low < high) {







      const middle = (low + high) >>> 1;







      if (boundaries[middle] <= current + .005) low = middle + 1;







      else high = middle;







    }







    return low - 1;







  };







  useEffect(() => {







    const previous = parentAnchor.current;







    const stamp = performance.now();







    const elapsed = previous.stamp == null ? 0 : (stamp - previous.stamp) / 1000;







    const expected = previous.time + (controller.current.playing ? elapsed * controller.current.rate : 0);







    const seek = previous.stamp != null && Math.abs(sourceTime - expected) > .6;







    parentAnchor.current = { time: sourceTime, stamp };







    // The media element is authoritative when available; otherwise changes to







    // the parent's time keep the interpolated fallback clock anchored.







    if (!(audioElement ?? audioRef?.current) && seek) {







      controller.current.syncId += 1;







      controller.current.boundary = -2;







      controller.current.time = sourceTime;







      setClock({ now: sourceTime, playing: audioStatus === 'Playing', rate: 1,







        syncId: controller.current.syncId, seeking: true });







    }







  }, [sourceTime, audioElement, audioRef]);







  useEffect(() => {







    const media = audioElement ?? audioRef?.current;







    let frame;







    const read = () => {







      const state = controller.current;







      const playing = media ? !media.paused && !media.ended : audioStatus === 'Playing';







      const rate = media ? media.playbackRate || 1 : 1;







      const anchor = parentAnchor.current;







      const current = media ? Math.max(0, media.currentTime || 0) : Math.max(0,







        anchor.time + (playing && anchor.stamp != null ? (performance.now() - anchor.stamp) / 1000 * rate : 0));







      const boundary = boundaryAt(current);







      return { current, boundary, playing, rate };







    };







    const update = (force = false, seek = false) => {







      const sample = read(), state = controller.current;







      const rateChanged = sample.rate !== state.rate;







      if (seek || rateChanged) state.syncId += 1;







      state.time = sample.current;







      if (force || seek || rateChanged || sample.boundary !== state.boundary || sample.playing !== state.playing) {







        state.boundary = sample.boundary;







        state.playing = sample.playing;







        state.rate = sample.rate;







        setClock({ now: sample.current, playing: sample.playing, rate: sample.rate,







          syncId: state.syncId, seeking: seek || rateChanged });







      }







      return sample.playing;







    };







    const tick = () => { if (update()) frame = requestAnimationFrame(tick); };







    const play = () => { cancelAnimationFrame(frame); update(true); frame = requestAnimationFrame(tick); };







    const stop = () => { cancelAnimationFrame(frame); update(true); };







    const seek = () => { update(true, true); };







    const rate = () => { update(true); };







    const sync = () => { update(); };







    if (media) {







      media.addEventListener('play', play); media.addEventListener('pause', stop);







      media.addEventListener('ended', stop); media.addEventListener('seeked', seek);







      media.addEventListener('ratechange', rate); media.addEventListener('timeupdate', sync);







    }







    controller.current.syncId += 1;







    update(true);







    if (read().playing) frame = requestAnimationFrame(tick);







    return () => {







      cancelAnimationFrame(frame);







      if (media) {







        media.removeEventListener('play', play); media.removeEventListener('pause', stop);







        media.removeEventListener('ended', stop); media.removeEventListener('seeked', seek);







        media.removeEventListener('ratechange', rate); media.removeEventListener('timeupdate', sync);







      }







    };







  }, [audioElement, audioRef, playbackId, audioStatus, boundaries]);







  return clock;







}







const MotionClock = createContext({ playing: true, rate: 1, syncId: 0 });







const DEFINITION_WORD_DURATION = .28;



const DEFINITION_CAPTION_STAGGER = 95;







// Same phrase-cued reveal as What Is Tribe: start a fresh word stagger for



// each caption, without ASR pauses, catch-up delays or a whole-caption slide.



function DefinitionText({ segments, text, wordDelay, reviewing = false, finishing = false,



  instant = false, as: Element = 'h1', className = '' }) {



  const { playing, rate, syncId } = useContext(MotionClock);



  const pieces = segments || [{ text }];



  const label = pieces.map(piece => piece.text).join(' ');



  const settled = useMemo(() => instant, [syncId]);



  let wordIndex = 0;



  return <Element className={className} aria-label={label}>



    {pieces.map((piece, pieceIndex) => {



      const words = piece.text.split(/\s+/).filter(Boolean);



      return <React.Fragment key={pieceIndex}>



        {pieceIndex > 0 && !piece.long ? ' ' : ''}



        <span className={`definition-reference-segment ${piece.long ? 'is-long' : ''}`}>



          {words.map((word, index) => {



            const globalIndex = wordIndex++;



            return <React.Fragment key={index}>



              <span key={syncId} className="definition-reference-word" style={{



                animationDelay: `${settled ? -10 : globalIndex * wordDelay / 1000 / rate}s`,



                animationDuration: `${DEFINITION_WORD_DURATION / rate}s`,



                animationPlayState: reviewing || finishing || playing ? 'running' : 'paused',



              }} aria-hidden="true">{word}</span>{index < words.length - 1 ? ' ' : ''}



            </React.Fragment>;



          })}



        </span>



      </React.Fragment>;



    })}



  </Element>;



}







function MotionScope({ clock, children }) {







  const value = useMemo(() => ({ playing: clock.playing, rate: clock.rate, syncId: clock.syncId }),







    [clock.playing, clock.rate, clock.syncId]);







  return <MotionClock.Provider value={value}>{children}</MotionClock.Provider>;







}







// Freeze delays at mount/cue/seek. Do not change animationDelay on every







// clock update: CSS runs the 380ms rise/fade smoothly between React renders.







function RevealText({ as: Element = 'span', text = '', segments, timings, start = 0, now = 0,







  delay = 0, complete = false, className = '' }) {







  const { playing, rate, syncId } = useContext(MotionClock);







  const pieces = segments || [{ text }];







  const ariaText = pieces.map(piece => piece.text).join(' ');







  const timingKey = timings?.join(',') ?? '';







  const origin = useMemo(() => now, [syncId, start, delay, complete, ariaText, timingKey, rate]);







  let wordIndex = 0;







  return <Element className={className} aria-label={ariaText}>







    {pieces.map((piece, pieceIndex) => <React.Fragment key={pieceIndex}>







      {pieceIndex > 0 ? ' ' : ''}







      <span className={piece.handwritten ? `training-handwritten ${piece.long ? 'is-long' : ''}` : 'training-plain'}>







        {piece.text.split(/\s+/).filter(Boolean).map((word, index, words) => {







          const indexInPhrase = wordIndex++;







          const revealAt = timings?.[indexInPhrase] ?? start + delay + indexInPhrase * .09;







          return <React.Fragment key={index}>







            <span key={syncId} className="training-reveal-word" aria-hidden="true" style={{







              animationDelay: `${complete ? -10 : (revealAt - origin) / rate}s`,







              animationDuration: `${.38 / rate}s`,







              animationPlayState: playing ? 'running' : 'paused',







            }}>{word}</span>{index < words.length - 1 ? ' ' : ''}







          </React.Fragment>;







        })}







      </span>







    </React.Fragment>)}







  </Element>;







}







// Phrase changes overlap briefly, without blurring the entire slide.







function SceneTransition({ sceneKey, start = 0, now, instant = false, children }) {







  const { playing, rate, syncId } = useContext(MotionClock);







  const origin = useMemo(() => now, [sceneKey, start, syncId, rate]);







  const previous = useRef({ key: sceneKey, syncId, children });







  const [outgoing, setOutgoing] = useState(null);







  useLayoutEffect(() => {







    const old = previous.current;







    const changed = old.key !== sceneKey;







    previous.current = { key: sceneKey, syncId, children };







    if (instant || old.syncId !== syncId) { setOutgoing(null); return undefined; }







    if (!changed) return undefined;







    setOutgoing(old);







    const timer = window.setTimeout(() => setOutgoing(null), 450 / rate);







    return () => window.clearTimeout(timer);







  }, [sceneKey, instant, syncId, rate]);







  useLayoutEffect(() => { previous.current.children = children; });







  return <div className="training-transition-shell">







    {outgoing && !instant && <div key={`out-${outgoing.key}`} className="training-scene-layer is-exiting" aria-hidden="true">{outgoing.children}</div>}







    <div key={`in-${sceneKey}-${syncId}`} className="training-scene-layer is-entering" style={{







      animationDelay: `${instant ? -10 : (start - origin) / rate}s`,







      animationDuration: `${.45 / rate}s`, animationPlayState: playing ? 'running' : 'paused',







    }}>{children}</div>







  </div>;







}







const REVEAL_STYLES = `







.training-plain {display:inline;}







.training-reveal-word {display:inline-block;opacity:0;transform:translateY(.36em);animation:training-word-in 380ms cubic-bezier(.18,.84,.22,1) both;}







.training-handwritten {display:inline-block;font-family:'Ugly Handwriting',cursive;font-size:1.12em;font-weight:400;letter-spacing:-.012em;line-height:.9;}







.training-handwritten.is-long {display:block;width:fit-content;max-width:100%;margin:.12em auto 0;}







.training-transition-shell {position:absolute;inset:0;overflow:hidden;}







.training-scene-layer {position:absolute;inset:0;}







.training-scene-layer.is-entering {z-index:2;animation:training-scene-enter 450ms cubic-bezier(.16,1,.3,1) both;}







.training-scene-layer.is-exiting {z-index:1;pointer-events:none;animation:training-scene-exit 450ms cubic-bezier(.4,0,.2,1) both;}







@keyframes training-word-in {to {opacity:1;transform:translateY(0);}}







@keyframes training-scene-enter {from {opacity:0;transform:translate3d(20px,10px,0);}to {opacity:1;transform:translate3d(0,0,0);}}







@keyframes training-scene-exit {from {opacity:1;transform:translate3d(0,0,0);}to {opacity:0;transform:translate3d(-18px,-8px,0);}}







.is-seeking .training-scene-layer.is-exiting {display:none;}







@media(prefers-reduced-motion:reduce){







 .training-reveal-word {animation:none;opacity:1;transform:none;}







 .training-scene-layer {animation:none!important;opacity:1;transform:none;filter:none;}







 .training-scene-layer.is-exiting {display:none;}







}







`;







const JOURNEY = [







  { id: 'welcome', label: 'Welcome', cue: 'First, welcome guests', Icon: STAGE_ICONS['welcome'] },







  { id: 'introduction', label: 'Introduction', cue: 'Once the event starts', Icon: STAGE_ICONS['introduction'] },







  { id: 'icebreaker', label: 'Icebreaker', cue: 'Then lead a short icebreaker', Icon: STAGE_ICONS['icebreaker'] },







  { id: 'first-activity', label: 'First activity', cue: 'After that, facilitate', Icon: STAGE_ICONS['first-activity'] },







  { id: 'transition', label: 'Transition', cue: 'When you’re changing activities', Icon: STAGE_ICONS['transition'] },







  { id: 'second-activity', label: 'Second activity', cue: 'Then guide the group', Icon: STAGE_ICONS['second-activity'] },







  { id: 'closing', label: 'Closing', cue: 'Finally, give the event', Icon: STAGE_ICONS['closing'] },







];







const DESKTOP_ROUTE = 'M35 200 ' + JOURNEY.map((_, i) => `A95 95 0 0 ${i % 2 === 0 ? 1 : 0} ${225 + i * 190} 200`).join(' ');







const MOBILE_POINTS = [[110,120],[350,120],[350,380],[110,380],[110,640],[350,640],[350,900]];







const MOBILE_ROUTE = 'M30 120 C30 15 230 15 230 120 C230 225 430 225 430 120 C455 170 455 330 430 380 C430 485 230 485 230 380 C230 275 30 275 30 380 C5 430 5 590 30 640 C30 535 230 535 230 640 C230 745 430 745 430 640 C455 690 455 850 430 900 C430 795 270 795 270 900';







function JourneyDiagram({ state, mobile = false }) {

  const diagramRef = useRef(null);

  const viewWidth = mobile ? 460 : 1400;

  const [unitScale, setUnitScale] = useState(mobile ? 1 : 1.25);



  // SVG coordinates scale with the route. Keep the icon circles, badges and

  // typography at the same displayed sizes as the other two lessons.

  useLayoutEffect(() => {

    const element = diagramRef.current;

    if (!element) return undefined;

    const measure = () => {

      const width = element.getBoundingClientRect().width;

      if (width > 0) setUnitScale(viewWidth / width);

    };

    measure();

    if (typeof ResizeObserver === 'undefined') return undefined;

    const observer = new ResizeObserver(measure);

    observer.observe(element);

    return () => observer.disconnect();

  }, [viewWidth]);



  const path = mobile ? MOBILE_ROUTE : DESKTOP_ROUTE;

  const progress = state.review ? 1 : Math.max(0, (state.active + 1) / JOURNEY.length);

  const radius = (mobile ? 38 : 44) * unitScale;

  const iconSize = (mobile ? 30 : 34) * unitScale;

  const badgeRadius = (mobile ? 12 : 13) * unitScale;

  const titleSize = (mobile ? 15 : 18) * unitScale;

  const numberSize = (mobile ? 10 : 11) * unitScale;



  return <svg ref={diagramRef} className={`journey-diagram ${mobile ? 'is-mobile' : 'is-desktop'}`}

    viewBox={mobile ? '0 0 460 1020' : '0 0 1400 400'} aria-hidden="true" focusable="false">

    <path className="journey-wave-base" d={path} />

    <path className="journey-wave-progress" d={path} pathLength="1" strokeDasharray="1 1" strokeDashoffset={1 - progress} />

    {JOURNEY.map((item, index) => {

      const [x,y] = mobile ? MOBILE_POINTS[index] : [130 + index * 190,200];

      const upper = index % 2 === 0;

      const direction = mobile || upper ? 1 : -1;

      const current = !state.review && state.active === index;

      const reached = state.review || state.active >= index;

      const stemStart = y + direction * radius;

      const stemEnd = stemStart + direction * (mobile ? 26 : 31) * unitScale;

      const dotY = stemEnd + direction * 2.5 * unitScale;

      const labelY = dotY + direction * ((mobile ? 20 : 22) * unitScale + titleSize / 2);

      const badgeX = x;

      const badgeY = mobile ? y - 91 : upper ? 72 : 352;

      const Icon = item.Icon;

      return <g key={item.id} className={`journey-step ${reached ? 'is-reached' : ''} ${current ? 'is-current' : ''}`}>

        <circle className="journey-stage-circle" cx={x} cy={y} r={radius} />

        <Icon className="journey-stage-icon" x={x - iconSize / 2} y={y - iconSize / 2}

          width={iconSize} height={iconSize} size={iconSize} />

        <circle className="journey-number-badge" cx={badgeX} cy={badgeY} r={badgeRadius} />

        <text className="journey-stage-number" x={badgeX} y={badgeY}

          dominantBaseline="central" style={{fontSize:numberSize}}>{index + 1}</text>

        <line className="journey-label-stem" x1={x} y1={stemStart} x2={x} y2={stemEnd} />

        <circle className="journey-label-dot" cx={x} cy={dotY} r={2.5 * unitScale} />

        <text className="journey-stage-label" x={x} y={labelY}

          dominantBaseline="central" style={{fontSize:titleSize}}>{item.label}</text>

      </g>;

    })}

    <circle className="journey-end-cap" cx={mobile ? 30 : 35} cy={mobile ? 120 : 200} r={2.5 * unitScale} />

    <circle className="journey-end-cap" cx={mobile ? 270 : 1365} cy={mobile ? 900 : 200} r={2.5 * unitScale} />

  </svg>;

}



function EventStructureScene(props) {







  const { duration = 0, wordTimings = props.words ?? EMPTY_TIMINGS, audioStatus, playbackId = 0 } = props;







  const narration = EventStructure.parts[0].narration;







  const timeline = useNarrationTimeline(narration, wordTimings, duration);







  const opening = useMemo(() => buildBeats(narration, timeline,







    ['Now', 'Every Tribe event'], JOURNEY[0].cue), [narration, timeline]);







  const starts = useMemo(() => JOURNEY.map(item => cueTime(narration, timeline, item.cue)), [narration, timeline]);







  const clock = useLessonClock(props, timeline);







  const { now, seeking } = clock;







  const review = audioStatus === 'Complete' || now >= cueTime(narration, timeline, 'You don’t need to memorize');







  let active = -1;







  starts.forEach((start, index) => { if (now >= start) active = index; });







  const state = { open: active >= 0 || review, review, active: review ? 6 : active };







  const beatIndex = activeIndex(opening, now), beat = opening[beatIndex];







  return <MotionScope clock={clock}><section className={`event-flow-scene ${state.open ? 'is-open' : ''} ${review ? 'is-reviewing' : ''} ${seeking ? 'is-seeking' : ''}`} data-timing-mode={timeline.mode}>







    <div className="event-flow-opening" aria-hidden={state.open}>







    <div className="event-flow-caption-center" key={`${playbackId}-${beatIndex}`}>



      <DefinitionText as="p" className="event-flow-opening-copy" text={beat.text}



        wordDelay={DEFINITION_CAPTION_STAGGER} instant={seeking || review} />



    </div>







    </div>







  {state.open && <div key={`${playbackId}-heading`}>



    <DefinitionText className="event-flow-heading" text="The Seven Stages of a Tribe Event"



      wordDelay={DEFINITION_CAPTION_STAGGER} reviewing={review} instant={seeking || review} />



  </div>}







    <div className="journey-diagrams" aria-hidden={!state.open}>







      <JourneyDiagram state={state} /><JourneyDiagram state={state} mobile />







      <ol className="journey-accessible-list">{JOURNEY.map((item, index) => <li key={item.id} aria-current={!review && active === index ? 'step' : undefined}>{item.label}</li>)}</ol>







    </div>







  </section></MotionScope>;







}







export default function EventStructure(props = {}) {







  return <div className="host-event-structure" aria-label={EventStructure.title}>







  <style>{HEADLINE_FONT_IMPORT + REVEAL_STYLES + JOURNEY_STYLES + DESIGN_STYLES + HEADLINE_FONT_STYLES + DEFINITION_REVEAL_STYLES + MATCHING_STYLES}</style><EventStructureScene {...props} />







  </div>;







}







const JOURNEY_STYLES = `







.host-event-structure {width:100%;background:#fff;color:#111;font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;}







.host-event-structure * {box-sizing:border-box;}







.host-event-structure .event-flow-scene {position:relative;min-height:490px;overflow:hidden;background:#fff;}







.host-event-structure .event-flow-opening {position:absolute;inset:0;opacity:1;transition:opacity 220ms ease,visibility 0ms linear 220ms;}







.host-event-structure .event-flow-caption-center {position:absolute;inset:0;display:flex;align-items:center;justify-content:center;padding:36px;}







.host-event-structure .is-open .event-flow-opening {opacity:0;visibility:hidden;pointer-events:none;}







.host-event-structure .event-flow-opening-copy {width:100%;max-width:950px;margin:0;font-family:inherit;font-size:clamp(38px,5.4vw,70px);font-weight:750;line-height:1.1;letter-spacing:-.04em;text-align:center;}







.host-event-structure .event-flow-heading {position:absolute;top:30px;left:50%;width:calc(100% - 64px);margin:0;transform:translate(-50%,12px);opacity:0;visibility:hidden;font-family:inherit;font-size:clamp(29px,3.25vw,43px);font-weight:750;line-height:1.12;letter-spacing:-.035em;text-align:center;transition:opacity 450ms ease,transform 650ms cubic-bezier(.18,.84,.22,1);}







.host-event-structure .is-open .event-flow-heading {opacity:1;visibility:visible;transform:translateX(-50%);}







.host-event-structure .journey-diagrams {width:calc(100% - 48px);max-width:1400px;margin:114px auto 38px;opacity:0;visibility:hidden;transform:translateY(16px);transition:opacity 600ms ease,transform 750ms cubic-bezier(.18,.84,.22,1);}







.host-event-structure .event-flow-scene:not(.is-open) .journey-diagrams {height:0;margin-top:0;margin-bottom:0;overflow:hidden;}







.host-event-structure .is-open .journey-diagrams {opacity:1;visibility:visible;transform:translateY(0);}







.host-event-structure .journey-diagram {display:block;width:100%;height:auto;overflow:visible;}







.host-event-structure .journey-diagram.is-mobile {display:none;}







.host-event-structure .journey-wave-base,.host-event-structure .journey-wave-progress {fill:none;stroke-width:2.5;stroke-linecap:round;}







.host-event-structure .journey-wave-base {stroke:#dedede;}







.host-event-structure .journey-wave-progress {stroke:#111;transition:stroke-dashoffset 750ms cubic-bezier(.18,.84,.22,1);}







.host-event-structure .journey-step {opacity:.22;transition:opacity 450ms ease;}







.host-event-structure .journey-step.is-reached {opacity:.52;}







.host-event-structure .journey-step.is-current,.host-event-structure .is-reviewing .journey-step {opacity:1;}







.host-event-structure .journey-stage-circle {fill:#fff;stroke:#111;stroke-width:2;}







.host-event-structure .journey-stage-icon {color:#111;}







.host-event-structure .journey-stage-label,.host-event-structure .journey-stage-number {font-family:inherit;text-anchor:middle;}







.host-event-structure .journey-stage-label {fill:#111;font-size:21px;font-weight:650;letter-spacing:-.35px;}







.host-event-structure .journey-stage-number {fill:#cfcfcf;font-size:36px;font-weight:700;transition:fill 450ms ease;}







.host-event-structure .is-current .journey-stage-number {fill:#111;}







.host-event-structure .journey-end-cap {fill:#fff;stroke:#111;stroke-width:1.5;}







.host-event-structure .journey-accessible-list {position:absolute;width:1px;height:1px;overflow:hidden;clip-path:inset(50%);white-space:nowrap;}







.host-training .ht-lesson-layout:has(.host-event-structure) {display:block;padding:0;}







.host-training .ht-lesson-layout:has(.host-event-structure)>.ht-lesson-copy {display:none;}







.host-training .ht-lesson-visual:has(.host-event-structure) {display:block;padding:0;background:#fff;border:0;border-radius:0;}







@media(min-width:701px) and (max-width:1000px){







 .host-event-structure .event-flow-scene {min-height:420px;}







 .host-event-structure .journey-diagrams {width:calc(100% - 32px);margin-top:125px;}







 .host-event-structure .journey-stage-label {font-size:23px;}







}







@media(max-width:700px){







 .host-event-structure .event-flow-scene {min-height:540px;}







 .host-event-structure .event-flow-caption-center {padding:24px;}







 .host-event-structure .event-flow-opening-copy {font-size:clamp(32px,8.4vw,46px);}







 .host-event-structure .event-flow-heading {top:28px;width:calc(100% - 36px);font-size:clamp(27px,6.6vw,36px);}







 .host-event-structure .journey-diagrams {width:calc(100% - 30px);max-width:460px;margin-top:120px;margin-bottom:20px;}







 .host-event-structure .journey-diagram.is-desktop {display:none;}







 .host-event-structure .journey-diagram.is-mobile {display:block;}







 .host-event-structure .journey-stage-label {font-size:22px;}







 .host-event-structure .journey-stage-number {font-size:29px;}







}







@media(prefers-reduced-motion:reduce){.host-event-structure .event-flow-opening,.host-event-structure .event-flow-heading,.host-event-structure .journey-diagrams,.host-event-structure .journey-wave-progress,.host-event-structure .journey-step,.host-event-structure .journey-stage-number {transition:none;}}







.host-event-structure .is-seeking .journey-wave-progress,.host-event-structure .is-seeking .journey-step {transition:none;}







`;







Object.assign(EventStructure, {







  slide: 3, id: 'event-structure', title: 'Event Structure', section: 'Background',







  parts: [{ part: 0, narration: "Now let’s look at how a Tribe event flows from start to finish. Every Tribe event follows seven stages.\nFirst, welcome guests as they arrive and help them join the group.\nOnce the event starts, introduce yourself and explain the plan.\nThen lead a short icebreaker so everyone can introduce themselves and start getting comfortable.\nAfter that, facilitate the first activity.\nMost events include more than one activity or location to keep the experience engaging. When you’re changing activities or moving somewhere else, make the transition clear. Tell guests what’s happening next or where the group is heading.\nThen guide the group through the second activity, continuing to help people connect.\nFinally, give the event a clear closing. Thank everyone for coming and explain how they can stay connected through Tribe.\nYou don’t need to memorize all of this. Before every event, we send hosts an event guide with a clear agenda, precise times, and instructions. It follows this structure and walks you through what to do for that event." }],







  summary: ['Know the flow. Follow your guide.', 'You do not need to memorize every phase.'],







});







const DESIGN_STYLES = `







.welcome-simple,.host-event-structure,.host-tribe-slide,.host-role-slide {







 --training-heading-size:clamp(29px,3.25vw,43px);







 --training-hero-size:clamp(38px,5.4vw,70px);







 font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;







 -webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;







}







.welcome-simple .welcome-simple-roadmap {max-width:1040px;padding-top:36px;}







.welcome-simple .welcome-simple-roadmap h1 {text-align:center;font-size:clamp(24px,2.55vw,32px);margin-bottom:72px;}







.welcome-simple .welcome-simple-caption,.host-event-structure .event-flow-opening-copy,.definition-caption h1,.tribe-concept-intro h1,.host-role-slide .role-heading {







 max-width:850px;font-size:clamp(32px,4vw,50px);line-height:1.12;letter-spacing:-.035em;







}







.welcome-simple .welcome-simple-number {width:26px;height:26px;font-size:11px;font-weight:500;font-variant-numeric:tabular-nums;}







.welcome-simple .welcome-simple-grid h2,.difference-field-item h2,.host-role-slide .role-column-heading h2 {font-size:clamp(18px,1.7vw,21px);line-height:1.3;}







.welcome-simple .welcome-simple-grid p,.difference-field-item p {font-size:clamp(13px,1.15vw,15px);line-height:1.55;}







.difference-field-title,.host-event-structure .event-flow-heading,.host-role-slide .is-open .role-heading {font-size:clamp(24px,2.55vw,32px);line-height:1.15;}







.difference-field {padding-top:36px;}







.difference-field-items {max-width:1040px;margin-top:80px;}







.difference-number,.host-role-slide .role-column-number {width:26px;height:26px;font-size:11px;}







.host-role-slide .role-column-number {flex-basis:26px;}







.host-role-slide .role-table {max-width:960px;}







.host-role-slide .role-table-cell p {font-size:clamp(18px,1.7vw,22px);}







.definition-review h1 {max-width:780px;font-size:clamp(27px,3vw,38px);}







.host-event-structure .event-flow-scene {min-height:530px;}







.host-event-structure .event-flow-heading {top:36px;}







.host-event-structure .journey-diagrams {max-width:1120px;margin-top:136px;}







.host-event-structure .journey-stage-label {font-size:21px;font-weight:650;}







.host-event-structure .journey-stage-number {font-size:30px;font-weight:500;}







@media(max-width:700px){







 .welcome-simple,.host-event-structure,.host-tribe-slide,.host-role-slide {







  --training-heading-size:clamp(27px,6.6vw,36px);--training-hero-size:clamp(32px,8.4vw,46px);







 }







 .host-event-structure .event-flow-scene {min-height:540px;}







 .welcome-simple .welcome-simple-caption,.host-event-structure .event-flow-opening-copy,.definition-caption h1,.tribe-concept-intro h1,.host-role-slide .role-heading {font-size:clamp(28px,7.6vw,38px);}







 .welcome-simple .welcome-simple-roadmap h1,.difference-field-title,.host-event-structure .event-flow-heading,.host-role-slide .is-open .role-heading {font-size:clamp(23px,5.8vw,29px);}







 .host-event-structure .event-flow-heading {top:28px;}







 .host-event-structure .journey-diagrams {max-width:460px;margin-top:112px;}







 .welcome-simple .welcome-simple-grid p,.difference-field-item p {font-size:14px;}







 .difference-field-items {margin-top:40px;}







 .host-role-slide .role-column-heading h2 {font-size:clamp(16px,4vw,19px);}







 .host-role-slide .role-table-cell p {font-size:clamp(16px,4vw,19px);}







}







`;











const HEADLINE_FONT_IMPORT = "@import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@700&display=swap');";







const HEADLINE_FONT_STYLES = `



.host-event-structure .event-flow-heading,



.host-event-structure .event-flow-opening-copy {



  font-family:'Merriweather',Georgia,'Times New Roman',serif;



  font-weight:700;



  font-style:normal;



  letter-spacing:-.015em;



}







.host-event-structure .event-flow-heading .training-handwritten,



.host-event-structure .event-flow-opening-copy .training-handwritten {



  font-family:inherit;



  font-weight:inherit;



  font-size:inherit;



  line-height:inherit;



  font-style:normal;



  letter-spacing:inherit;



  transform:none;



}



`;







const DEFINITION_REVEAL_STYLES = `



.host-event-structure .definition-reference-word {



  display:inline-block;opacity:0;transform:translateY(.16em);



  animation:definition-reference-word-in 280ms cubic-bezier(.18,.84,.22,1) both;



}



.host-event-structure .definition-reference-segment {display:inline;}



.host-event-structure .definition-reference-segment.is-long {



  display:block;width:fit-content;max-width:100%;margin:.12em auto 0;



}



@keyframes definition-reference-word-in {to {opacity:1;transform:translateY(0);}}



.host-event-structure .event-flow-heading,



.host-event-structure .is-open .event-flow-heading {



  opacity:1;visibility:visible;transform:translateX(-50%);transition:none;



}



@media(prefers-reduced-motion:reduce){



  .host-event-structure .definition-reference-word {animation:none;opacity:1;transform:none;}



}



`;





const MATCHING_STYLES = `

.host-event-structure .event-flow-opening-copy {

  max-width:800px;font-size:clamp(28px,3.2vw,40px);line-height:1.25;letter-spacing:-.015em;

}

.host-event-structure .event-flow-heading {

  font-size:clamp(24px,2.55vw,32px);line-height:1.15;letter-spacing:-.015em;

}

.host-event-structure .journey-stage-circle {

  fill:none;stroke:#111;stroke-width:1.3;vector-effect:non-scaling-stroke;

}

.host-event-structure .journey-number-badge {fill:#ededed;stroke:none;}

.host-event-structure .journey-stage-number {

  fill:#111;font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;

  font-weight:600;letter-spacing:0;font-variant-numeric:tabular-nums;

}

.host-event-structure .journey-stage-label {

  fill:#111;font-family:'Merriweather',Georgia,'Times New Roman',serif;

  font-weight:700;letter-spacing:-.015em;

}

.host-event-structure .journey-label-stem {

  stroke:#111;stroke-width:1;vector-effect:non-scaling-stroke;

}

.host-event-structure .journey-label-dot,.host-event-structure .journey-end-cap {fill:#111;stroke:none;}

.host-event-structure .journey-wave-base,.host-event-structure .journey-wave-progress {

  stroke-width:1;vector-effect:non-scaling-stroke;

}

.host-event-structure .journey-step {opacity:.2;}

.host-event-structure .journey-step.is-reached {opacity:.38;}

.host-event-structure .journey-step.is-current,

.host-event-structure .is-reviewing .journey-step {opacity:1;}

@media(max-width:700px){

  .host-event-structure .event-flow-opening-copy {font-size:clamp(26px,6.6vw,34px);}

  .host-event-structure .event-flow-heading {font-size:clamp(22px,5.8vw,32px);}

}

`;
